var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHabikon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.447,
    height: 31.741,
    viewBox: "0 0 191.447 31.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(-16.642 -9.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1873",
    "data-name": "Trac\\xE9 1873",
    d: "M35.93,43.942H33.458V32.59H19.1V43.942H16.642V18.961H19.1V30.28h14.36V18.961H35.93Z",
    transform: "translate(0 -3.675)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1874",
    "data-name": "Trac\\xE9 1874",
    d: "M83.047,43.942h-2.6l-2.2-5.66H66.263l-2.212,5.66H61.465l9.66-24.981h2.26ZM67.124,35.989H77.386L72.28,22.523h-.065Z",
    transform: "translate(-16.697 -3.675)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1875",
    "data-name": "Trac\\xE9 1875",
    d: "M128.888,36.851a6.754,6.754,0,0,1-2.13,5.009,7.11,7.11,0,0,1-5.156,2.081H109.942V18.961h11.092a6.591,6.591,0,0,1,4.748,1.92,6.174,6.174,0,0,1,1.984,4.6,5.232,5.232,0,0,1-.935,3.065,6.564,6.564,0,0,1-2.3,2.073v.065a7.3,7.3,0,0,1,3.082,2.4A6.032,6.032,0,0,1,128.888,36.851ZM112.4,29.728h8.636a4.017,4.017,0,0,0,2.984-1.236,4.292,4.292,0,0,0-.024-6,4.042,4.042,0,0,0-2.96-1.236H112.4ZM124.969,40.25a4.626,4.626,0,0,0,1.4-3.4,4.68,4.68,0,0,0-1.4-3.415A4.563,4.563,0,0,0,121.6,32.02H112.4v9.628H121.6A4.591,4.591,0,0,0,124.969,40.25Z",
    transform: "translate(-34.754 -3.675)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1876",
    "data-name": "Trac\\xE9 1876",
    d: "M155.567,43.942V18.961h2.456V43.942Z",
    transform: "translate(-51.75 -3.675)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1877",
    "data-name": "Trac\\xE9 1877",
    d: "M183.687,31.452l12.458,12.49h-3.4l-12.328-12.49v12.49h-2.456V18.961h2.456V31.452l12.328-12.491h3.4Z",
    transform: "translate(-60.092 -3.675)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1878",
    "data-name": "Trac\\xE9 1878",
    d: "M236.132,21.884a12.528,12.528,0,0,1,3.862,9.23,12.529,12.529,0,0,1-3.862,9.229,13.273,13.273,0,0,1-18.654,0,12.529,12.529,0,0,1-3.862-9.229,12.528,12.528,0,0,1,3.862-9.23,13.271,13.271,0,0,1,18.654,0Zm-1.789,16.857a10.5,10.5,0,0,0,3.114-7.627,10.5,10.5,0,0,0-3.114-7.628,10.564,10.564,0,0,0-15.093,0,10.494,10.494,0,0,0-3.114,7.628,10.494,10.494,0,0,0,3.114,7.627,10.564,10.564,0,0,0,15.093,0Z",
    transform: "translate(-73.373 -3.338)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1879",
    "data-name": "Trac\\xE9 1879",
    d: "M289.591,18.961V43.942h-2.472L272.792,23.027l-.033.033V43.942H270.3V18.961h2.456l14.328,20.914.033-.032V18.961Z",
    transform: "translate(-94.489 -3.675)",
    fill: "#141317"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3623",
    "data-name": "Groupe 3623",
    transform: "translate(200.346 9.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1880",
    "data-name": "Trac\\xE9 1880",
    d: "M309.4,13.17a4.236,4.236,0,0,1,.51-2.046,3.821,3.821,0,0,1,1.413-1.487,3.772,3.772,0,0,1,3.9,0,3.828,3.828,0,0,1,1.411,1.487,4.236,4.236,0,0,1,.51,2.046,4.285,4.285,0,0,1-.491,2.014,3.894,3.894,0,0,1-1.394,1.509,3.742,3.742,0,0,1-3.961.005,3.884,3.884,0,0,1-1.4-1.5A4.263,4.263,0,0,1,309.4,13.17Zm.628,0a3.564,3.564,0,0,0,.437,1.737,3.244,3.244,0,0,0,1.187,1.251,3.127,3.127,0,0,0,3.255-.008,3.267,3.267,0,0,0,1.182-1.252,3.687,3.687,0,0,0,0-3.448A3.226,3.226,0,0,0,314.9,10.2a3.157,3.157,0,0,0-3.258-.006,3.212,3.212,0,0,0-1.187,1.246A3.544,3.544,0,0,0,310.026,13.167Zm2.444.412v1.845H311.7V10.791h1.506a2.073,2.073,0,0,1,1.3.358,1.235,1.235,0,0,1,.461,1.039,1.112,1.112,0,0,1-.7,1.026,1.089,1.089,0,0,1,.671,1.113v.333a1.784,1.784,0,0,0,.093.677v.087h-.791a2.191,2.191,0,0,1-.077-.7,5.783,5.783,0,0,0-.016-.6q-.088-.523-.715-.546Zm0-.7h.852a1.082,1.082,0,0,0,.633-.19.561.561,0,0,0,.24-.473.672.672,0,0,0-.213-.563,1.279,1.279,0,0,0-.758-.166h-.754Z",
    transform: "translate(-309.399 -9.094)",
    fill: "#141317"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabikon);
export default __webpack_public_path__ + "static/media/habikon.535bee5a0e122e0b765fe22b846764ac.svg";
export { ForwardRef as ReactComponent };